function createPayload({ dataBeneficiario, dataForm, addressType, dependents }) {
    let payload = [
        {
            codigoMotivoSegundaVia: dataForm.reason.value,
            codigoTipoCartao: dataForm.reason.cartao?.tipo,

            numeroAssociadoOuNumeroCarteira: dataBeneficiario.numCarteirinha,
            emitidoPor: dataForm.issuedBy.value,

            codigoTipoEnderecoCarteira: addressType.codigo,
            tipoAssociado :dataBeneficiario.tipo === "TITULAR" ? 'T' : 'B',
        },
    ];

    dependents.forEach(dependent => {
        if(dependent.checked) {
            payload = [...payload, {
                codigoMotivoSegundaVia: dataForm.reason.value,
                codigoTipoCartao: dataForm.reason.cartao?.tipo,
    
                numeroAssociadoOuNumeroCarteira: dependent.numCarteirinha,
                emitidoPor: dependent.emitidoPor,
    
                codigoTipoEnderecoCarteira: addressType.codigo,
                tipoAssociado: "D",
            }]
        }
    })

    return payload;
}

export default createPayload;
